import { SocketTopics, SocketTradeData } from "@shared/types";
import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import useSocket from "@shared/features/socket/useSocket";
import { GLOBAL_PNL_MIN_TRADES } from "@shared/services/socket/constants";

const useSocketPnl = (openTradesData?: SocketTradeData[]) => {
  const numOfTrades = openTradesData?.length || 0;
  const useGlobalPnl = numOfTrades > GLOBAL_PNL_MIN_TRADES;

  const socketPnlArgs = useMemo(() => {
    if (!openTradesData || useGlobalPnl) return skipToken;
    const tradeIds = openTradesData?.map((trade) => trade.id);
    return tradeIds?.length ? { tradeIds } : skipToken;
  }, [openTradesData, useGlobalPnl]);

  const socketGlobalPnlArgs = useMemo(() => {
    if (!openTradesData || !useGlobalPnl) return skipToken;
    return undefined;
  }, [openTradesData, useGlobalPnl]);

  const socketPnlData = useSocket<SocketTopics.PNL>(
    SocketTopics.PNL,
    socketPnlArgs
  );
  const socketGlobalPnlData = useSocket<SocketTopics.GLOBAL_PNL>(
    SocketTopics.GLOBAL_PNL,
    socketGlobalPnlArgs
  );

  return {
    socketPnlValue: (useGlobalPnl ? socketGlobalPnlData : socketPnlData)?.value,
    useGlobalPnl,
  };
};

export default useSocketPnl;
